module.exports = __webpack_public_path__ + "img/_homePad_pack_logo.37a57c15.svg";